import {
  BoldItalicUnderlineToggles,
  diffSourcePlugin,
  MDXEditor,
  toolbarPlugin
} from '@mdxeditor/editor'
import '@mdxeditor/editor/style.css'
import { memo, useEffect, useRef, useState } from "react"
import { useTranslation } from "react-i18next"
import { ReactComponent as DeleteIcon } from "../../assets/images/icons/ic-delete.svg"
import styles from "./TrueFalseQuestion.module.css"

const TrueFalseQuestion = ({ id, label, onDelete = () => { }, onChange = () => { }, text = "", value = null }) => {

  const [_text, setText] = useState(text)
  const [_value, setValue] = useState(value)
  const { t } = useTranslation()
  const onChangeTimeout = useRef(null)

  useEffect(() => {
    if (onChangeTimeout.current) {
      clearTimeout(onChangeTimeout.current)
    }

    onChangeTimeout.current = setTimeout(() => {
      onChange({ id, text: _text, value: _value })
    }, 120)

    return () => {
      if (onChangeTimeout.current) {
        clearTimeout(onChangeTimeout.current)
      }
    }
  }, [id, _text, _value, onChange])

  useEffect(() => {
    if (text !== _text) {
      setText(text)
    }

    if (value !== _value) {
      setValue(value)
    }
  }, [text, value])

  return (
    <div className={styles.answerRow}>
      <div className={styles.container}>
        <div className={styles.left}>
          <div className={styles.label}>{label}</div>
          <div className="_mdxeditor-inline">
            <MDXEditor
              className={styles.editor}
              contentEditableClassName={styles.editorContent}
              markdown={_text}
              onChange={(value) => {
                setText(value)
              }}
              placeholder={t("tests.answerPlaceholderTrueFalse")}
              plugins={[
                diffSourcePlugin(),
                toolbarPlugin({
                  toolbarContents: () => (
                    <BoldItalicUnderlineToggles options={["Bold", "Italic"]} />
                  )
                })
              ]}
            />
          </div>
        </div>
        <div className={styles.actions}>
          <div className={styles.choiceField}>
            <span className={styles.choiceLabel}>Risposta corretta</span>
            <div className={styles.choiceGroup} role="group" aria-label={`Risposta corretta ${label}`}>
              <button type="button" aria-pressed={_value === true} onClick={() => setValue(true)}>Vero</button>
              <button type="button" aria-pressed={_value === false} onClick={() => setValue(false)}>Falso</button>
            </div>
          </div>
          <button type="button" className={styles.delete} aria-label={`Rimuovi risposta ${label}`} onClick={onDelete}><DeleteIcon /></button>
        </div>
      </div>
    </div>
  )
}

const areEqual = (prevProps, nextProps) => {
  return prevProps.id === nextProps.id &&
    prevProps.label === nextProps.label &&
    prevProps.text === nextProps.text &&
    prevProps.value === nextProps.value
}

export default memo(TrueFalseQuestion, areEqual)
